/**
 * Created by ZhangJunPeng on 2017/5/24.
 */

import React from 'react';
import MoreMeeting from './MoreMeeting';
import { FormattedMessage } from 'react-intl';

export default class MoreMeetingIndex extends React.Component {
  render() {
    const {
      meetingTree,
      onMeetingChange,
      intl,
      selected,
      current,
      message,
      showType,
      disabled,
      showCommon,
      needAudit,
      selectRoomName,
      cmmaMeeting,
      multiple,
      treeCheckable
    } = this.props;
    return (
      <div className="detail-flex-div">
        <p className="name">
          <FormattedMessage id={message || 'add_more_meeting'} />：
        </p>
        <div className="new-peo">
          <MoreMeeting
            ref={a => (this._a = a)}
            showType={showType}
            meetingTree={meetingTree}
            selected={selected}
            current={current}
            disabled={disabled}
            showCommon={showCommon}
            selectRoomName={selectRoomName}
            onMeetingChange={onMeetingChange}
            intl={intl}
            cmmaMeeting={cmmaMeeting}
            multiple={multiple}
            treeCheckable={treeCheckable}
          />
          {needAudit &&
            !disabled && (
              <span className="audit-warning">
                <FormattedMessage id="need_room_admin_audit" />
              </span>
            )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/meeting/MoreMeetingIndex.js